import styled from "styled-components"

export const CardContainer = styled.section`
height: 400px;
background: #05386B;
position: relative;

@media screen and (max-width: 768px){
    height: auto
}
`

export const CardWrapper = styled.div`
display: grid;
grid-template-columns: 1fr 1fr 1fr 1fr;
grid-gap: 5px;
max-width: 1100px;
margin: 0 auto;

@media screen and (max-width: 768px){
    grid-template-columns: 1fr;
}
`

export const CardItem = styled.div`
border: 2px solid #05386B;
border-radius: 10px;
background:#EEE2DC;
height: 15rem;
color: #05386B;
margin-top: 5rem;
box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2);

@media screen and (max-width: 768px){
    width: 70%;
    justify-self:center;
    margin-top:0.5rem;
    margin-bottom: 1rem;
}
`

export const CardImage = styled.div`
font-size: 5rem;
color: #C3073F;
display: flex;
justify-content: center;
margin-bottom: 1rem;
`

export const CardHeading = styled.h2`
display:flex;
justify-content: center;
padding-bottom: 5px;

@media screen and (max-width: 768px){
    font-size: 1.3rem;
}
`

export const CardP = styled.p`
display: flex;
justify-content: center;
line-height: 1.3;
margin-left:1rem;
`